import { useEffect, useRef, useState } from 'react';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import antMessage from '../../../utils/extend/AntdNotification';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { Button, Select, Switch, Image, Modal, Form, Row, Col } from 'antd';
import DimSumEdit from '../menu/DimSumEdit';
import DimSumCategory from './DimSumCategory';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import getList from '../../universal/getList';
import dayjs from 'dayjs';

//组件 ShowMenu
export default function ShowDimSum(props: any) {

    const [form] = Form.useForm(); //form 
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    const notificationApi = useNotificationInstance();

    const [shopTypeIdData, setShopTypeIdData] = useState<any>();
    const [shopTypeData, setShopTypeData] = useState<any>();

    //调整点心单分类窗口
    const [dimSumCategoryVisible, setDimSumCategoryVisible] = useState(false);

    //点心单分类数据
    const [dimSumCategoryData, setDimSumCategoryData] = useState<any>();

    //历代点心单数据
    const [dimSumHistoryData, setDimSumHistoryData] = useState<any>();

    //显示复制按钮
    const [showCopy, setShowCopy] = useState<any>(false);

    //复制窗口
    const [copyVisible, setCopyVisible] = useState(false);

    /** api服务id */
    const apiId = 'dimSumDetail';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
            await fetchCategory();


            if (dayjs(data.startTime).format("YYYY-MM-DD") <= dayjs().format("YYYY-MM-DD") && dayjs(data.endTime).format("YYYY-MM-DD") >= dayjs().format("YYYY-MM-DD")) {
                setShowCopy(true);
            }
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //刷新Category数据
    const fetchCategory = () => {
        fetchApi.GET(wmService, {
            apiId: "dimSumCategory",
            apiExtend: 'showList',
            apiData: {
                dimSumHistoryId: data.dimSumHistoryId
            }
        }).then(res => {
            if (res.success) {
                let newData = [{ id: "999", shopTypeName: "所有分类" }, ...res.data];
                setShopTypeData(newData)
            }
        })
    }

    //改变数据
    const handleChange = async (id: any, columnName: string, isValue: boolean) => {
        const bodys = {
            apiId: "dimSumDetail",
            apiVariable: id,
            apiExtend: "updateSingle",
            apiData: {
                columnName,
                isValue
            }
        }
        fetchApi.PUT(wmService, bodys).then(res => {
            showCustomNotification(notificationApi!, {
                type: 'success',
                message: '编辑成功',
                description: 'success',
            });;
            initData();
        }).catch(err => {
            antMessage('error', '删编辑失败', err.message);
        })
    };

    //查看不同分类的菜式
    const shopTypeChange = (e: any) => {
        setShopTypeIdData(e);
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                shopTypeId: e,
                dimSumHistoryId: data.dimSumHistoryId
            }
        }
        ref.current.initData(currentData);
    };

    const handleCancel = (e: any) => {
        closeModal(false);
    };

    const initData = async () => {
        const dimSumHistoryId = data.dimSumHistoryId;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                dimSumHistoryId
            }
        }
        ref.current.initData(currentData);
    }

    //关闭调整类别顺序窗口
    const onCloseDimSumCategory = async (status: boolean) => {
        setDimSumCategoryVisible(false)
        if (status) {
            await initData();
        }
    }

    //复制
    const handleCopy = () => {
        fetchApi.GET(wmService, {
            apiId: "dimSumHistory",
            apiExtend: 'showList',
            apiData: {
                branchStoreId: data.branchStoreId,
                dimSumHistoryId: data.dimSumHistoryId,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                },
            }
        }).then(res => {
            if (res.success) {
                setDimSumHistoryData(res.data);
            }
        })

        setCopyVisible(true);
    };

    const onCloseCopy = () => {
        setCopyVisible(false);
    };

    const handleOk = () => {
        form.validateFields()
            .then((values: any) => {
                fetchApi.GET(wmService, {
                    apiId: "dimSumHistory",
                    apiExtend: 'copy',
                    apiData: {
                        ...values,
                        currentDimSumHistoryId: data.dimSumHistoryId,
                    }
                }).then(async (res) => {
                    if (res.success) {
                        setCopyVisible(false);
                        await fetchCategory();
                        await initData();
                    }
                }).catch((err) => {
                    // showCustomNotification(notificationApi!, {
                    //     type: 'error',
                    //     message: '错误',
                    //     description: err
                    // });
                    antMessage("error", "复制失败", err);
                })
            })
            .catch((err) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            })
    };

    //调整类别顺序
    const handleDimSumCategorySortBy = () => {
        sendData.dimSumHistoryId = data.dimSumHistoryId;
        sendData.dimSumHistoryName = data.dimSumHistoryName;
        sendData.brandId = data.brandId;
        sendData.brandName = data.brandName;
        sendData.branchStoreId = data.branchStoreId;
        sendData.branchStoreName = data.branchStoreName;
        setDimSumCategoryData(sendData);
        setDimSumCategoryVisible(true);
    };

    //表头
    const columnsHead = [
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                if (record.expandFoodName) {
                    return (
                        <div>{record.expandFoodName + " (原名称：" + record.foodName + ")"}</div>
                    )
                }
                else {
                    return (
                        <div>{record.foodName}</div>
                    )
                }
            }
        },
        {
            title: '分类',
            dataIndex: 'dimSumCategoryName',
            render: (text: any, record: any) => {
                if (record.dimSumCategory) {
                    return (
                        <div>{record.dimSumCategory.shopTypeName
                        }</div>
                    )
                }
            }
        },
        {
            title: '价格',
            dataIndex: 'price',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
        {
            title: '图片',
            dataIndex: 'pic',
            render: (text: any, record: any) => {
                if (record.fileDestination) {
                    return (
                        <Image
                            src={record.filesServerUrl + '/' + record.fileDestination}
                            width={60}
                            alt="图片"
                        />
                    )
                }
            }
        },

        sessionStorage.getItem('isAdmin') === 'true' ?
            {
                title: '状态',
                dataIndex: 'isUse',
                render: (text: any, record: any) => (
                    <Switch checkedChildren="启用" unCheckedChildren="不启用"
                        checked={text} key={record.id}
                        onChange={(e) => handleChange(record.id, 'isUse', e)}
                    />
                )
            } : {},
    ];

    /** 子表头 */
    const columns = columnsheadId
        .concat(columnsHead as []);

    //传关参数
    let sendData = {
        type: 'EDIT',
        dimSumHistoryId: '',
        dimSumHistoryName: '',
        brandId: '',
        brandName: '',
        branchStoreId: '',
        branchStoreName: ''
    }

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '点心单菜式',
        apiId,
        columns,
        showStates: false,
        showOperation: true,
        pagination: true,
        isAutomaticRefresh: true,
        showDelete: sessionStorage.getItem('isAdmin') === 'true' ? true : false,
        showAdd: false,
        EditComponent: DimSumEdit,
        sendPageData: {
            shopTypeId: shopTypeIdData,
            dimSumHistoryId: data.dimSumHistoryId
        },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        },
    };

    return (
        <>
            <AntDraggableModal
                title={data.brandName + " " + data.branchStoreName + " 【" + data.dimSumHistoryName + "】 菜式"}
                open={true}
                okText='关闭'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleCancel}
                onCancel={handleCancel}
                closable={false}
                // maskClosable={false}
                width={1000}
            >
                <Modal
                    title="复制点心单"
                    open={copyVisible}
                    okText='确定'
                    onOk={handleOk}
                    onCancel={onCloseCopy}
                    style={{ fontSize: '20px' }}
                    width={600}
                >
                    <Form
                        form={form}
                        name="Edit"
                    >
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="历代点心单"
                                    name="dimSumHistoryId"
                                    rules={[{ required: true, message: '请选择点心单!' }]}>
                                    <Select
                                        showSearch
                                        placeholder="选择点心单"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(dimSumHistoryData, 'dimSumHistoryName')}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                {showCopy
                    ? (<Button type="primary" onClick={handleCopy}>复制点心单</Button>)
                    : null}
                <span>&nbsp;&nbsp;</span>
                <Button type="primary" onClick={handleDimSumCategorySortBy}>调整类别顺序</Button>
                <span>&nbsp;&nbsp;</span>
                <Select
                    style={{ width: 150 }}
                    showSearch
                    defaultValue="所有类别"
                    onChange={shopTypeChange}
                    placeholder="菜式类别"
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.generalEx(shopTypeData, {
                        itemName: "shopTypeName",
                        includeNull: false
                    })}
                </Select>
                <span>&nbsp;&nbsp;</span>
                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            </AntDraggableModal>

            {dimSumCategoryVisible
                ? (<DimSumCategory
                    closeModal={onCloseDimSumCategory} data={dimSumCategoryData} />)
                : null}
        </>
    )
}